// Placeholder for the AI tab. Phase 2 lands the real content; for now
// this matches the rollout plan's promise of an empty "coming soon" tab.
export default function AiPlaceholder() {
  return (
    <div className="rounded-lg border border-border bg-panel p-8">
      <h2 className="text-lg font-semibold mb-2">AI</h2>
      <p className="text-sm text-muted">Coming soon.</p>
    </div>
  );
}
